import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Deep-link shim: wizard lives in a modal on the list page.
 * /sa/AssessmentBlueprints/new and /:id redirect there with state.
 */
const AssessmentBlueprintWizard = () => {
  const { id: routeId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!routeId || routeId === "new") {
      navigate("/sa/AssessmentBlueprints", {
        replace: true,
        state: { openBlueprintWizard: "new" },
      });
      return;
    }
    const parsed = Number(routeId);
    navigate("/sa/AssessmentBlueprints", {
      replace: true,
      state: { openBlueprintWizard: parsed > 0 ? parsed : "new" },
    });
  }, [navigate, routeId]);

  return null;
};

export default AssessmentBlueprintWizard;
